module.exports = __webpack_public_path__ + "media/bootstrap-icons/outlet-469fe0f0.svg";